const MOCK_USER_KEY = 'screen_mock_current_user'

const MOCK_USERS = [
  {
    id: 1,
    phone: '13800000001',
    password: 'admin123',
    username: 'admin',
    role: 'administrator',
    displayName: '合江县荔枝大屏管理员'
  }
]

function wait(ms = 180) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

function getStoredUser() {
  const raw = window.localStorage.getItem(MOCK_USER_KEY)
  if (!raw) {
    return null
  }

  try {
    return JSON.parse(raw)
  } catch (error) {
    window.localStorage.removeItem(MOCK_USER_KEY)
    return null
  }
}

function setStoredUser(user) {
  window.localStorage.setItem(MOCK_USER_KEY, JSON.stringify(user))
}

function clearStoredUser() {
  window.localStorage.removeItem(MOCK_USER_KEY)
}

export async function getCurrentUser() {
  await wait()
  const user = getStoredUser()

  if (!user) {
    return {
      code: 40100,
      message: 'Not logged in',
      data: null
    }
  }

  return {
    code: 200,
    message: 'ok',
    data: user
  }
}

export async function loginByPhonePassword(phone, password) {
  await wait()

  const matchedUser = MOCK_USERS.find(
    user => user.phone === phone && user.password === password
  )

  if (!matchedUser) {
    return {
      code: 40001,
      message: 'Incorrect phone number or password',
      data: null
    }
  }

  const currentUser = {
    id: matchedUser.id,
    phone: matchedUser.phone,
    username: matchedUser.username,
    role: matchedUser.role,
    displayName: matchedUser.displayName
  }

  setStoredUser(currentUser)

  return {
    code: 200,
    message: 'ok',
    data: currentUser
  }
}

export async function logout() {
  await wait(80)
  clearStoredUser()

  return {
    code: 200,
    message: 'ok',
    data: true
  }
}
